import { buildSortEventsPrompt } from '@/ai/prompts'
import { fetchJsonResponse, streamJsonResponses } from '@/ai/api'

export const generateSortEvents = async ({
  workflow,
  events,
  stream = true,
  onChunkReceived,
  abortController
}) => {
  if (!events?.length) {
    return null
  }
  if (stream && typeof onChunkReceived !== 'function') {
    return null
  }

  const messages = buildSortEventsPrompt({ events, stream })

  if (stream) {
    const response = await streamJsonResponses({
      messages,
      useCase: 'workflow-diagram',
      aiVersion: workflow.aiVersion,
      onChunkReceived,
      signal: abortController?.signal
    })

    return response || null
  } else {
    const response = await fetchJsonResponse({
      messages,
      useCase: 'workflow-diagram',
      aiVersion: workflow.aiVersion,
      signal: abortController?.signal
    })

    return response || null
  }
}
